module.exports = __webpack_public_path__ + "img/image-launch-vehicle-landscape.1d7d8789.jpg";